var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmployeeSelfService(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 17,
    r: 17,
    fill: "#227AFF",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 20V16.25M17 20V14M20 20V18.5M21.5 11H12.5C12.1022 11 11.7206 11.158 11.4393 11.4393C11.158 11.7206 11 12.1022 11 12.5V21.5C11 21.8978 11.158 22.2793 11.4393 22.5606C11.7206 22.842 12.1022 23 12.5 23H21.5C21.8978 23 22.2793 22.842 22.5606 22.5606C22.842 22.2793 23 21.8978 23 21.5V12.5C23 12.1022 22.842 11.7206 22.5606 11.4393C22.2793 11.158 21.8978 11 21.5 11Z",
    stroke: "#227AFF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmployeeSelfService);
export default __webpack_public_path__ + "static/media/employee-self-service.02bb38f96607d6655eb90507ecdc7f97.svg";
export { ForwardRef as ReactComponent };